module.exports = __webpack_public_path__ + "img/printf.4422e23a.png";